var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5-layout"},[_c('app-main',{staticClass:"h5-layout__content"}),_c('navbar',{staticClass:"h5-layout__tabbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }